module.exports = __webpack_public_path__ + "media/images/w_logo-ee340eaa.png";